export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de almacenes"])},
          "inventory_movements_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Movimientos"])},
          "inventory_items_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Items"])},
          "new_inbound_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar entrada"])},
          "new_outbound_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar salida"])},
          "new_item_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar item"])},
          "destroy_item_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar item ", _interpolate(_named("item"))])},
          "destroy_item_button_message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["¿Está seguro de eliminar el item ", _interpolate(_named("item")), "?"])},
          "destroy_item_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_movement_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar movimiento"])},
          "destroy_movement_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el movimiento?"])},
          "destroy_movement_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}